import type { AlertEvent, PoolDef } from '../../shared/types';

const KIND_LABEL: Record<AlertEvent['kind'], string> = { fire: 'fired', escalate: 'escalated', recover: 'recovered' };

/** Recent alert events, newest first. `notified = false` means the Matrix send failed for that run. */
export function AlertsFeed({ alerts, pools }: { alerts: AlertEvent[]; pools: PoolDef[] }) {
  if (!alerts.length) return null;
  const name = (id: string) => pools.find((p) => p.id === id)?.name ?? id;
  const watchOnly = (id: string) => pools.find((p) => p.id === id)?.watchOnly === true;
  return (
    <section class="panel">
      <h2 class="panel-title">Recent alerts</h2>
      <ul class="alerts-list">
        {alerts.map((a) => (
          <li key={a.id} class="alert">
            <time class="mono" dateTime={new Date(a.ts * 1000).toISOString()}>
              {new Date(a.ts * 1000).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
            </time>
            <span class={`pill ${a.kind === 'recover' ? 'pill--ok' : a.severity === 'critical' ? 'pill--critical' : 'pill--warn'}`}>
              {a.kind === 'recover' ? 'recovered' : `${a.severity} ${KIND_LABEL[a.kind]}`}
            </span>
            <span class="alert-body">
              <strong>{name(a.poolId)}</strong> · {a.title}
              {a.detail && <span class="dim"> — {a.detail}</span>}
              {watchOnly(a.poolId)
                ? <span class="pill" title="Watch-only venue: recorded here, never sent to Matrix">watch only</span>
                : !a.notified && a.kind !== 'recover' && <span class="pill" title="No channel accepted the notice for this run">not sent</span>}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
